import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Landmark, CheckCircle2 } from "lucide-react";

export default function PrivateBanking() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/private-banking").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  if (!cfg) return <p className="text-muted-foreground">Loading…</p>;
  const fmt = (n) => "$" + Number(n).toLocaleString();
  return (
    <div className="animate-fade-up max-w-4xl" data-testid="private-banking-page">
      <div className="mb-8">
        <p className="text-xs tracking-[0.2em] uppercase text-primary font-bold mb-2">Funding</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight leading-none">Private Banking</h1>
        <p className="text-muted-foreground mt-3 text-sm max-w-2xl">Once a client reaches a <b>{cfg.min_score}+</b> credit score they're approved for private banking funding from <b>{fmt(cfg.min_amount)}</b> up to <b>{fmt(500000000)}</b>, scaled by their score tier.</p>
      </div>

      <Card className="p-6 bg-card/60 border-border mb-6" data-testid="pb-tiers">
        <h3 className="font-display text-xl font-semibold mb-4">Approval Tiers</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {cfg.tiers.map((t) => (
            <div key={t.min_score} className="rounded-lg border border-border p-4 bg-background/40" data-testid={`pb-tier-${t.min_score}`}>
              <div className="text-xs uppercase tracking-widest text-muted-foreground">Score {t.range}</div>
              <div className="text-2xl font-bold font-mono mt-1 text-primary">{fmt(t.max_amount)}</div>
              <div className="text-xs text-muted-foreground">max approval</div>
            </div>
          ))}
        </div>
      </Card>

      <Card className="p-6 bg-card/60 border-border mb-6" data-testid="pb-instructions">
        <h3 className="font-display text-xl font-semibold mb-3">Approval Instructions</h3>
        <pre className="whitespace-pre-wrap font-sans text-sm leading-relaxed text-muted-foreground">{cfg.instructions}</pre>
      </Card>

      <Card className="p-6 bg-card/60 border-border" data-testid="pb-institutions">
        <h3 className="font-display text-xl font-semibold mb-3 flex items-center gap-2"><Landmark className="h-5 w-5 text-primary" /> Partner Institutions</h3>
        <div className="grid sm:grid-cols-2 gap-2">
          {cfg.institutions.map((i, idx) => (
            <div key={idx} className="flex items-center gap-2 text-sm" data-testid={`pb-institution-${idx}`}><CheckCircle2 className="h-4 w-4 text-emerald-400 shrink-0" /> {i}</div>
          ))}
        </div>
      </Card>
    </div>
  );
}
